export default "__VITE_ASSET__DIqwVQiy__"